import axios from "axios";

export async function getBizOverview(token) {
    const url = "https://dupe-admin-6gxsdymdsq-ue.a.run.app/api/v1/biz/overview";
    const result = await axios.get(url, { headers: {'X-CLIENT-ID': token}});
    return result;
}